import type { Source } from "."

export default class implements Source {
  async fetch(_query: string): Promise<any> {
    return await Promise.resolve()
  }
}
